import {
  COD_ERRO_REGRA_NEGOCIO,
  COD_ERRO_SESSAO_EXPIRADA,
} from "@/common/constantes.js";
import { MessageToast } from "../componentes/Message.jsx";

export const MENSAGENS_ERRO = {
  CAMPOS_OBRIGATORIOS: 1,

  DATA_INVALIDA: 2,
  DIAMES_INVALIDO: 3,
  MESANO_INVALIDO: 4,
  ANO_INVALIDO: 5,

  PERIODO_MAX_MESES: 6,
  PERIODO_MAX_DIAS: 7,

  VALOR_NUMERICO: 8,
  ESPACO_BRANCO: 9,

  VALOR_MINIMO_PERMITIDO: 10,
  VALOR_MAXIMO_PERMITIDO: 11,
  VALOR_MAIOR_DO_QUE_X: 12,
  CAMPO_X_MAIOR_DO_QUE_Y: 13,

  DATA_ANTERIOR_OU_IGUAL_ATUAL: 19,
  DATA_POSTERIOR_OU_IGUAL_ATUAL: 20,

  DATA_INICIO_FIM_DENTRO_MES: 21,
  DATA_INICIO_ANTERIOR_OU_IGUAL_DATA_FIM: 22,
  DATA_FIM_POSTERIOR_OU_IGUAL_DATA_INICIO: 23,
  DATA_FIM_ANTERIOR_OU_IGUAL_DATA_ATUAL: 24,

  DATA_X_POSTERIOR_DATA_Y: 25,
  DATA_X_ANTERIOR_DATA_Y: 26,
  DATA_X_POSTERIOR_OU_IGUAL_DATA_Y: 27,
  DATA_X_ANTERIOR_OU_IGUAL_DATA_Y: 28,

  DATA_JA_CADASTRADA: 29,

  NAO_PERMITE_EXCLUIR_DATA_ANTERIOR_ATUAL: 30,
  NAO_PERMITE_EXCLUIR_DATA_ANTERIOR_MESANO_ATUAL: 31,

  MESANO_X_POSTERIOR_MESANO_Y: 32,
  MESANO_X_ANTERIOR_MESANO_Y: 33,
  MESANO_X_POSTERIOR_OU_IGUAL_MESANO_Y: 34,
  MESANO_X_ANTERIOR_OU_IGUAL_MESANO_Y: 35,

  ANO_ANTERIOR_OU_IGUAL_ANO_ATUAL: 36,
  ANO_POSTERIOR_OU_IGUAL_ANO_ATUAL: 37,

  SELECIONE_PELOMENOSUM: 38,
  SELECIONE_PELOMENOSUMA: 39,
  ADICIONE_PELOMENOSUM: 40,
  ADICIONE_PELOMENOSUMA: 41,
  OBRIGATORIO_PELOMENOSUM: 42,
  OBRIGATORIO_PELOMENOSUMA: 43,

  ADICIONE_PARA_CONFIRMAR: 44,

  INFORME_VALOR_CAMPO_X: 45,
  INFORME_CAMPO_X: 46,
  SELECIONE_CAMPO_X: 47,
  CORRIJA_ERRO_CAMPO_X: 48,

  VALOR_CAMPO_X_DEVE_SER_MENOR_DO_QUE_VALOR_CAMPO_Y: 49,
  VALOR_CAMPO_X_NAO_PODE_SER_NEGATIVO: 50,

  CAMPO_X_NAO_ALTERADO: 51,

  INCORRETA: 60,
  INVALIDO: 61,
  INATIVO: 62,

  NAO_ENCONTRADO: 63,
  NAO_ENCONTRADA: 64,
  JA_ADICIONADO: 65,
  JA_EXISTE: 66,

  TENTATIVA_OPERACAO: 1000,

  //Mensagens específicas de regra de negócio
  CNPJ_RAIZ_DIF_CNPJ_EMPRESA: 108,

  SENHA_QTDE_MIN_CARACTERES: 109,
  SENHA_PELO_MENOS_UMA_LETRA: 110,
  SENHA_PELO_MENOS_UM_NUMERO: 111,
  SENHA_NOVA_DIF_SENHA_ATUAL: 112,

  CENTRO_CUSTO_ADM_CD_CODIGO_INICIAL: 113,
  CENTRO_CUSTO_LOJA_CODIGO_MAX: 114,

  RATEIO_SEM_INF_FAT_MES_ANO: 115,
  RATEIO_SEM_INF_QTDE_COLAB_MES_ANO: 116,

  VERIFIQUE_ERROS_PARCELAS: 117,

  PAGAMENTO_UNICO_QTDE_DEVE_SER_1: 118,
  TIPO_DOCUMENTO_CONTRATO_SO_PERMITE_CONTRATO: 119,
  CONTRATO_SUSPENSO: 120,
  CONTRATO_SEM_INDICE_REAJUSTE: 121,
  MES_ANO_REF_FORA_VIGENCIA_CONTRATO: 122,

  DATA_FERIADO_ATENDIMENTO: 123,
  DATA_DIA_SEMANA_X: 124,
};

export const MENSAGENS_AVISO = {
  QTDE_INCLUSAO_QTDE_ATUALIZACAO: 1,
  PRIMEIRO_ACESSO: 2,
  SENHA_DEVE_SER_ALTERADA_PRIMEIRO_ACESSO: 3,
  NENHUMA_ALTERACAO_REALIZADA: 4,
  NENHUMA_EXCECAO_INCLUIDA_EXCLUIDA: 5,
  NENHUM_REGISTRO_RETORNADO: 6,
};

export const MENSAGENS_SUCESSO = {
  OPERACAO_SUCESSO: 1,
  EMAIL_ENVIADO: 2,
};

export const MENSAGENS_INFO = {
  DOWNLOAD_CONCLUIDO: 1,
};

/*
 * Obtém a mensagem de ERRO de acordo com o código definido em MENSAGENS_ERRO
 * @codigo: Código da mensagem obtido em MENSAGENS_ERRO.
 * @param1, param2: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function getMensagemErro(codigo, param1, param2) {
  let mensagem;

  switch (codigo) {
    case MENSAGENS_ERRO.CAMPOS_OBRIGATORIOS:
      mensagem = `Verifique os campos obrigatórios em vermelho. ${
        param1 ? param1 : ""
      }`;
      break;

    case MENSAGENS_ERRO.DATA_INVALIDA:
      mensagem = "Data inválida.";
      break;

    case MENSAGENS_ERRO.DIAMES_INVALIDO:
      mensagem = "Dia/Mês inválido.";
      break;

    case MENSAGENS_ERRO.MESANO_INVALIDO:
      mensagem = "Mês/Ano inválido.";
      break;

    case MENSAGENS_ERRO.ANO_INVALIDO:
      mensagem = "Ano inválido.";
      break;

    case MENSAGENS_ERRO.PERIODO_MAX_MESES:
      mensagem = `O período máximo é de ${param1} meses.`;
      break;

    case MENSAGENS_ERRO.PERIODO_MAX_DIAS:
      mensagem = `O período máximo é de ${param1} dias${param2 || ""}.`;
      break;

    case MENSAGENS_ERRO.VALOR_NUMERICO:
      mensagem = `O valor deve ser numérico.`;
      break;

    case MENSAGENS_ERRO.ESPACO_BRANCO:
      mensagem = `O campo ${param1} não pode conter espaços em branco.`;
      break;

    case MENSAGENS_ERRO.SELECIONE_PELOMENOSUM:
      mensagem = `Selecione pelo menos um ${param1}.`;
      break;

    case MENSAGENS_ERRO.SELECIONE_PELOMENOSUMA:
      mensagem = `Selecione pelo menos uma ${param1}.`;
      break;

    case MENSAGENS_ERRO.ADICIONE_PELOMENOSUM:
      mensagem = `Adicione pelo menos um ${param1}.`;
      break;

    case MENSAGENS_ERRO.ADICIONE_PELOMENOSUMA:
      mensagem = `Adicione pelo menos uma ${param1}.`;
      break;

    case MENSAGENS_ERRO.ADICIONE_PARA_CONFIRMAR:
      mensagem = `Adicione ${param1} para confirmar.`;
      break;

    case MENSAGENS_ERRO.OBRIGATORIO_PELOMENOSUM:
      mensagem = `É obrigatório ter pelo menos um ${param1}.`;
      break;

    case MENSAGENS_ERRO.OBRIGATORIO_PELOMENOSUMA:
      mensagem = `É obrigatório ter pelo menos uma ${param1}.`;
      break;

    case MENSAGENS_ERRO.INFORME_VALOR_CAMPO_X:
      mensagem = `Informe o valor ${param1}.`;
      break;

    case MENSAGENS_ERRO.INFORME_CAMPO_X:
      mensagem = `Informe ${param1}.`;
      break;

    case MENSAGENS_ERRO.SELECIONE_CAMPO_X:
      mensagem = `Selecione ${param1}.`;
      break;

    case MENSAGENS_ERRO.CORRIJA_ERRO_CAMPO_X:
      mensagem = `Corrija o erro ${param1}.`;
      break;

    case MENSAGENS_ERRO.VALOR_CAMPO_X_DEVE_SER_MENOR_DO_QUE_VALOR_CAMPO_Y:
      mensagem = `Valor ${param1} deve ser menor do que o valor ${param2}.`;
      break;

    case MENSAGENS_ERRO.VALOR_CAMPO_X_NAO_PODE_SER_NEGATIVO:
      mensagem = `Valor ${param1} não pode ser negativo.`;
      break;

    case MENSAGENS_ERRO.CAMPO_X_NAO_ALTERADO:
      mensagem = `O campo ${param1} não foi alterado.`;
      break;

    case MENSAGENS_ERRO.INCORRETA:
      mensagem = `${param1} incorreta.`;
      break;

    case MENSAGENS_ERRO.INVALIDO:
      mensagem = `${param1} inválido.`;
      break;

    case MENSAGENS_ERRO.INATIVO:
      mensagem = `${param1} inativo.`;
      break;

    case MENSAGENS_ERRO.NAO_ENCONTRADO:
      mensagem = `${param1} não encontrado.`;
      break;

    case MENSAGENS_ERRO.NAO_ENCONTRADA:
      mensagem = `${param1} não encontrada.`;
      break;

    case MENSAGENS_ERRO.JA_ADICIONADO:
      mensagem = `${param1} já adiconado.`;
      break;

    case MENSAGENS_ERRO.JA_EXISTE:
      mensagem = `${param1} já existe.`;
      break;

    case MENSAGENS_ERRO.DATA_ANTERIOR_OU_IGUAL_ATUAL:
      mensagem = "A data deve ser anterior ou igual à data atual.";
      break;

    case MENSAGENS_ERRO.DATA_POSTERIOR_OU_IGUAL_ATUAL:
      mensagem = "A data deve ser posterior ou igual à data atual.";
      break;

    case MENSAGENS_ERRO.DATA_INICIO_FIM_DENTRO_MES:
      mensagem = `Data início e fim devem estar dentro do mesmo mês.`;
      break;

    case MENSAGENS_ERRO.DATA_INICIO_ANTERIOR_OU_IGUAL_DATA_FIM:
      mensagem = `Data início deve ser anterior ou igual à data fim.`;
      break;

    case MENSAGENS_ERRO.DATA_FIM_POSTERIOR_OU_IGUAL_DATA_INICIO:
      mensagem = `Data fim deve ser posterior ou igual à data início.`;
      break;

    case MENSAGENS_ERRO.DATA_FIM_ANTERIOR_OU_IGUAL_DATA_ATUAL:
      mensagem = `Data fim deve ser anterior ou igual à data atual.`;
      break;

    case MENSAGENS_ERRO.DATA_X_POSTERIOR_DATA_Y:
      mensagem = `Data ${param1} deve ser posterior à data ${param2}.`;
      break;

    case MENSAGENS_ERRO.DATA_X_ANTERIOR_DATA_Y:
      mensagem = `Data ${param1} deve ser anterior à data ${param2}.`;
      break;

    case MENSAGENS_ERRO.DATA_X_POSTERIOR_OU_IGUAL_DATA_Y:
      mensagem = `Data ${param1} deve ser posterior ou igual à data ${param2}.`;
      break;

    case MENSAGENS_ERRO.DATA_X_ANTERIOR_OU_IGUAL_DATA_Y:
      mensagem = `Data ${param1} deve ser anterior ou igual à data ${param2}.`;
      break;

    case MENSAGENS_ERRO.DATA_JA_CADASTRADA:
      mensagem = `Data já cadastrada.`;
      break;

    case MENSAGENS_ERRO.NAO_PERMITE_EXCLUIR_DATA_ANTERIOR_ATUAL:
      mensagem = `Não é permitido excluir data anterior à data atual.`;
      break;

    case MENSAGENS_ERRO.NAO_PERMITE_EXCLUIR_DATA_ANTERIOR_MESANO_ATUAL:
      mensagem = `Não é permitido excluir data anterior ao mês/ano atual.`;
      break;

    case MENSAGENS_ERRO.MESANO_X_POSTERIOR_MESANO_Y:
      mensagem = `Mês/Ano ${param1} deve ser posterior ao mês/ano ${param2}.`;
      break;

    case MENSAGENS_ERRO.MESANO_X_ANTERIOR_MESANO_Y:
      mensagem = `Mês/Ano ${param1} deve ser anterior ao mês/ano ${param2}.`;
      break;

    case MENSAGENS_ERRO.MESANO_X_POSTERIOR_OU_IGUAL_MESANO_Y:
      mensagem = `Mês/Ano ${param1} deve ser posterior ou igual ao mês/ano ${param2}.`;
      break;

    case MENSAGENS_ERRO.MESANO_X_ANTERIOR_OU_IGUAL_MESANO_Y:
      mensagem = `Mês/Ano ${param1} deve ser anterior ou igual ao mês/ano ${param2}.`;
      break;

    case MENSAGENS_ERRO.ANO_ANTERIOR_OU_IGUAL_ANO_ATUAL:
      mensagem = `Ano deve ser anterior ou igual ao ano atual.`;
      break;

    case MENSAGENS_ERRO.ANO_POSTERIOR_OU_IGUAL_ANO_ATUAL:
      mensagem = `Ano deve ser posterior ou igual ao ano atual.`;
      break;

    case MENSAGENS_ERRO.VALOR_MINIMO_PERMITIDO:
      mensagem = `Valor mínimo permitido: ${param1}.`;
      break;

    case MENSAGENS_ERRO.VALOR_MAXIMO_PERMITIDO:
      mensagem = `Valor máximo permitido: ${param1}.`;
      break;

    case MENSAGENS_ERRO.VALOR_MAIOR_DO_QUE_X:
      mensagem = `O valor deve ser maior do que ${param1}.`;
      break;

    case MENSAGENS_ERRO.CAMPO_X_MAIOR_DO_QUE_Y:
      mensagem = `${param1} deve ser maior do que ${param2}.`;
      break;

    case MENSAGENS_ERRO.CNPJ_RAIZ_DIF_CNPJ_EMPRESA:
      mensagem = "CNPJ deve possuir a raiz do CNPJ da empresa";
      break;

    case MENSAGENS_ERRO.SENHA_QTDE_MIN_CARACTERES:
      mensagem = `A senha deve ter no mínimo ${param1} caracteres.`;
      break;

    case MENSAGENS_ERRO.SENHA_PELO_MENOS_UMA_LETRA:
      mensagem = "A senha deve conter pelo menos uma letra.";
      break;

    case MENSAGENS_ERRO.SENHA_PELO_MENOS_UM_NUMERO:
      mensagem = "A senha deve conter pelo menos um número.";
      break;

    case MENSAGENS_ERRO.SENHA_NOVA_DIF_SENHA_ATUAL:
      mensagem = "Nova senha deve ser diferente da senha atual.";
      break;

    case MENSAGENS_ERRO.CENTRO_CUSTO_ADM_CD_CODIGO_INICIAL:
      mensagem = `Centro de custo que não é loja deve ter código maior ou igual a ${param1}.`;
      break;

    case MENSAGENS_ERRO.CENTRO_CUSTO_LOJA_CODIGO_MAX:
      mensagem = `Centro de custo LOJA deve ter código menor do que ${param1}.`;
      break;

    case MENSAGENS_ERRO.RATEIO_SEM_INF_FAT_MES_ANO:
      mensagem = `Não foi encontrado faturamento em nenhuma filial no mês/ano ${param1}.`;
      break;

    case MENSAGENS_ERRO.RATEIO_SEM_INF_QTDE_COLAB_MES_ANO:
      mensagem = `Não foi encontrado qtde colaborador em nenhum centro de custo no mês/ano ${param1}.`;
      break;

    case MENSAGENS_ERRO.VERIFIQUE_ERROS_PARCELAS:
      mensagem = "Verifique os erros em vermelho nas parcelas.";
      break;

    case MENSAGENS_ERRO.PAGAMENTO_UNICO_QTDE_DEVE_SER_1:
      mensagem = "Para pagamento único, a quantidade de pagamento deve ser 1.";
      break;

    case MENSAGENS_ERRO.TIPO_DOCUMENTO_CONTRATO_SO_PERMITE_CONTRATO:
      mensagem =
        "Tipo documento Contrato/Acordo só é permitido se possuir contrato.";
      break;

    case MENSAGENS_ERRO.CONTRATO_SUSPENSO:
      mensagem = "Esse contrato está suspenso.";
      break;

    case MENSAGENS_ERRO.CONTRATO_SEM_INDICE_REAJUSTE:
      mensagem = "O contrato está sem índice de reajuste cadastrado.";
      break;

    case MENSAGENS_ERRO.MES_ANO_REF_FORA_VIGENCIA_CONTRATO:
      mensagem =
        "Mês/ano ref. deve estar dentro do período de vigência do contrato.";
      break;

    case MENSAGENS_ERRO.DATA_FERIADO_ATENDIMENTO:
      mensagem =
        "Essa data é um feriado. Ela só pode ser incluída no atendimento de Feriado.";
      break;

    case MENSAGENS_ERRO.DATA_DIA_SEMANA_X:
      mensagem = `A data deve ser ${param1}. Essa data é ${param2}`;
      break;

    case MENSAGENS_ERRO.TENTATIVA_OPERACAO:
      mensagem = `Erro ao tentar ${param1}.`;
      break;
    default:
      mensagem = codigo;
  }

  return mensagem;
}

/*
 * Obtém a mensagem de AVISO de acordo com o código definido em MENSAGENS_AVISO
 * @codigo: Código da mensagem obtido em MENSAGENS_AVISO.
 * @param1, param2, param3: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function getMensagemAviso(codigo, param1, param2, param3) {
  let mensagem;

  switch (codigo) {
    case MENSAGENS_AVISO.QTDE_INCLUSAO_QTDE_ATUALIZACAO:
      mensagem = `Incluídos: ${param1}. Atualizados: ${param2}.\n${
        param3 || ""
      }`;
      break;

    // case MENSAGENS_AVISO.QTDE_REGISTROS_ALTERADOS:
    //   mensagem = `${param1} registros alterados. Verifique para salvar.`;
    //   break;

    // case MENSAGENS_AVISO.NENHUM_REGISTRO_ALTERADO:
    //   mensagem = "Nenhum registro sofreu alteração.";
    //   break;

    case MENSAGENS_AVISO.NENHUMA_ALTERACAO_REALIZADA:
      mensagem = "Nenhuma alteração foi realizada.";
      break;

    case MENSAGENS_AVISO.NENHUMA_EXCECAO_INCLUIDA_EXCLUIDA:
      mensagem = `Nenhuma exceção foi incluída ou excluída. ${param1 || ""}`;
      break;

    case MENSAGENS_AVISO.NENHUM_REGISTRO_RETORNADO:
      mensagem = `Nenhum registro retornado. ${param1 || ""}`;
      break;

    // case MENSAGENS_AVISO.NENHUM_REGISTRO_RETORNADO:
    //   mensagem = "Nenhum registro retornado.";
    //   break;

    // case MENSAGENS_AVISO.NENHUM_REGISTRO_GERADO:
    //   mensagem = "Nenhum registro foi gerado.";
    //   break;

    // case MENSAGENS_AVISO.NENHUM_REGISTRO_IMPORTADO:
    //   mensagem = "Nenhum registro foi importado.";
    //   break;

    // case MENSAGENS_AVISO.QTDE_ENVIADO_QTDE_ERRO:
    //   mensagem = `Enviados: ${param1}. Erro: ${param2}.\n${param3 || ""}`;
    //   break;

    // case MENSAGENS_AVISO.QTDE_PROCESSADO_QTDE_ERRO:
    //   mensagem = `Processados: ${param1}. Erro: ${param2}.\n${param3 || ""}`;
    //   break;

    // case MENSAGENS_AVISO.QTDE_IMPORTADO_QTDE_ERRO:
    //   mensagem = `Importados: ${param1}. Erro: ${param2}.\n${param3 || ""}`;
    //   break;

    case MENSAGENS_AVISO.PRIMEIRO_ACESSO:
      mensagem = `Primeiro acesso! É ${param1} alterar a senha por segurança`;
      break;

    case MENSAGENS_AVISO.SENHA_DEVE_SER_ALTERADA_PRIMEIRO_ACESSO:
      mensagem = "A senha deve ser alterada no primeiro acesso";
      break;

    default:
      mensagem = codigo;
  }

  return mensagem;
}

/*
 * Obtém a mensagem de SUCESSO de acordo com o código definido em MENSAGENS_SUCESSO
 * @codigo: Código da mensagem obtido em MENSAGENS_SUCESSO.
 * @param1: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function getMensagemSucesso(codigo, param1) {
  let mensagem;

  switch (codigo) {
    case MENSAGENS_SUCESSO.OPERACAO_SUCESSO:
      mensagem = `Operação realizada com sucesso.\n${param1 || ""}`;
      break;

    case MENSAGENS_SUCESSO.EMAIL_ENVIADO:
      mensagem = "E-mail enviado.";
      break;

    default:
      mensagem = codigo;
  }

  return mensagem;
}

/*
 * Obtém a mensagem de INFO de acordo com o código definido em MENSAGENS_INFO
 * @codigo: Código da mensagem obtido em MENSAGENS_INFO.
 * @param1: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function getMensagemInfo(codigo, param1) {
  let mensagem;

  switch (codigo) {
    case MENSAGENS_INFO.DOWNLOAD_CONCLUIDO:
      mensagem = `Download concluído.`;
      break;

    default:
      mensagem = codigo;
  }

  return mensagem;
}

/*
 * Apresenta a mensagem de erro de acordo com o código definido em MENSAGENS_ERRO
 * @codigo: Código da mensagem obtido em MENSAGENS_ERRO.
 * @param1, param2: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function showMensagemErro(codigo, param1, param2) {
  const mensagem = getMensagemErro(codigo, param1, param2);
  if (mensagem) {
    MessageToast("error", mensagem);
  }
}

/*
 * Mensagem de erro apresentada no tratamento de exceção das chamadas de API
 */
export function showMensagemErroApi(error, cplMensagem) {
  let mensagem = `Erro ao tentar ${cplMensagem}: ${
    error.response?.data || error.message || ""
  }`;

  if (error.response) {
    const status = error.response?.status;

    if (status != COD_ERRO_SESSAO_EXPIRADA) {
      //Se for erro tratado no backend
      if (status == COD_ERRO_REGRA_NEGOCIO) {
        mensagem = error.response.data;
      }
      //Se for erro de arquivo não encontrado
      else if (status == 404) {
        mensagem = "Arquivo não encotrando.";
      }
      //Se for erro de arquivo não encontrado
      else if (status == 413) {
        mensagem = "Requisição com conteúdo muito grande.";
      }
    }
  } else {
    mensagem = "Falha na comunicação com o servidor.";
  }

  MessageToast("error", mensagem);
}

/*
 * Apresenta a mensagem de aviso de acordo com o código definido em MENSAGENS_AVISO
 * @codigo: Código da mensagem obtido em MENSAGENS_AVISO.
 * @param1, param2, param3: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function showMensagemAviso(codigo, param1, param2, param3) {
  const mensagem = getMensagemAviso(codigo, param1, param2, param3);
  if (mensagem) {
    MessageToast("warning", mensagem);
  }
}

/*
 * Apresenta a mensagem de sucesso de acordo com o código definido em MENSAGENS_SUCESSO
 * @codigo: Código da mensagem obtido em MENSAGENS_SUCESSO.
 * @param1: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function showMensagemSucesso(codigo, param1) {
  const mensagem = getMensagemSucesso(codigo, param1);
  if (mensagem) {
    MessageToast("success", mensagem);
  }
}

/*
 * Apresenta a mensagem de informação de acordo com o código definido em MENSAGENS_INFO
 * @codigo: Código da mensagem obtido em MENSAGENS_INFO.
 * @param1: Opcional para utilizar na montagem da mensagem quando necessário
 */
export function showMensagemInfo(codigo, param1) {
  const mensagem = getMensagemInfo(codigo, param1);
  if (mensagem) {
    MessageToast("info", mensagem);
  }
}
